export default __webpack_public_path__ + "static/media/uploader-abbottLite-problem-1.7033b55d.png";